import { formatReadableDate } from "utils/formatDate"

export const DOT = ""

export const COMPANY = {
  name: "Aurobil Cars",
  phone: "(+88) 01911-887-731",
  email: "aurobilcars@gmail.com",
  address: "Ka-82, Kuril, Progati Sarani, Vatara, Dhaka-1229",
}

export const formatAmount = (value, suffix = "") => {
  if (value === null || value === undefined || value === "") return DOT
  if (!isNaN(Number(value))) {
    return (
      new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
        Number(value)
      ) + suffix
    )
  }
  return String(value)
}

export const stripHtml = value => {
  const text = String(value ?? "")
    .replace(/<br\s*\/?>(\r\n|\r|\n)?/gi, "\n")
    .replace(/<\/(p|div|li|h[1-6])>/gi, "\n\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<[^>]+>/g, "")
  return text
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
}

const ALLOWED_INLINE_TAGS = new Set([
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "sub",
  "sup",
  "br",
  "span",
])

export const sanitizeInlineHtml = value => {
  const text = String(value ?? "")
    .replace(/<\/(p|div|li|h[1-6])>/gi, "\n\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<(\/?)([a-z0-9]+)(\s[^>]*)?>/gi, (match, slash, tag) => {
      if (ALLOWED_INLINE_TAGS.has(tag.toLowerCase())) {
        return `<${slash}${tag.toLowerCase()}>`
      }
      return ""
    })
    .replace(/\n{3,}/g, "\n\n")
    .trim()

  return text
}

export const findSpec = (specs, keys) => {
  const lowered = keys.map(k => String(k).toLowerCase())
  const match = (specs || []).find(item =>
    lowered.includes(String(item?.key ?? "").toLowerCase())
  )
  return match?.value ?? null
}

export const splitParagraphs = text =>
  !text
    ? []
    : text
        .split(/\n\s*\n/)
        .map(p => p.trim())
        .filter(Boolean)

export const splitLines = text =>
  !text
    ? []
    : text
        .split(/\r\n|\r|\n/)
        .map(l => l.trim())
        .filter(Boolean)

export const formatPdfDate = value => {
  if (!value) return DOT
  const formatted = formatReadableDate(value, "MMMM d, y")
  return formatted === "-" ? value : formatted
}

export const splitCompanyName = name => {
  const parts = String(name || "").trim().split(/\s+/)
  if (!parts.length) return { lead: "", last: "" }
  const last = parts.pop()
  return { lead: parts.join(" "), last }
}
